module.exports = __webpack_public_path__ + "static/media/overloaded.47cbb7b4.png";